module.exports = __webpack_public_path__ + "img/download_ios.319d098d.png";